import { STORE_TIMEOUT_MODAL_IS_OPEN } from "actions"

export const initialState = {
  timeoutModalIsOpen: false,
}

export const timeout = (state = initialState, action) => {
  switch (action.type) {
    case STORE_TIMEOUT_MODAL_IS_OPEN:
      return { ...state, timeoutModalIsOpen: action.payload }
    default:
      return state
  }
}
export default timeout
